export default __webpack_public_path__ + "static/if-else-if-6d653ce47ad75c633eedda97f9bbfa02.svg";